import { baseBUCGet } from '../base/baseBUC';

const int = 0;
const str = '';
const decimal = 0.00;
const dateTimeStr = new Date()?.toISOString();

export const purchaseModelGet = ({
    buildingId = '',
    supplierId = '',
    userId = '',
}) => {
    return {
        supplierId: supplierId,
        taxId: str,
        balance: decimal,
        date: dateTimeStr,
        description: str,
        exemptAmount: decimal,
        files: [],
        invoiceNumber: str,
        invoiceControlNumber: str,
        number: int,
        taxBase: decimal,
        taxAmount: decimal,
        taxPercentage: decimal,
        total: decimal,
        status: int,
        subTotal: decimal,
        ...baseBUCGet({ buildingId: buildingId, userId: userId, }),
    }
};

export const purchaseDetailModelGet = ({
    buildingId = '',
    expenseConceptId = '',
    purchaseId = '',
    taxId = '',
}) => {
    return {
        buildingId: buildingId,
        description: str,
        expenseConceptId: expenseConceptId,
        price: decimal,
        purchaseId: purchaseId,
        quantity: decimal,
        remark: str,
        taxId: taxId,
        taxPercentage: decimal,
    };
};